import { formatearFechaCompleta,formatearPrecio } from '../../../../utils/utils';
import React from 'react'
import { 
  Clock, 
  Video,
  RefreshCw,
  Lock,
  ChevronRight, 
  FileCheck, 
  Bell, 
  DollarSign, 
  RotateCcw, 
  Eye, 
  AlertTriangle,
  FileText,
  AlertCircle,
  Settings,
  CheckCircle,
  XCircle,
  Send,
} from 'lucide-react';
import DescripcionActividadSolicitud from '../../solicitudes/components/infoSolicitudes';
import FileUploader from '../../../../components/FileUploader';
import FileViewer from '../../../../components/FileViewer';
import ConstruccionWidget from '../../../../components/Loadings/ConstruccionWidget';
import ContainerPagos from '../Modulos/ContainerPagos';
import FileViewerBien from '../../../../components/FileViewerBien';
import ModuloRevision from '../ModuloRevision';

const ClienteViewServicio = ({
  servicio, 
  visibleTabs,
  handleTabChange,
  activeTab,
  solicitud,
  nombreEmpresaReal,
}) => {


  const ClienteView = () =>{
    return (
        <div>
        {/* Info de entrega - Cards con iconos */}
        {/* Fecha limite, precio cobrado, codigo de servicio */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6 bg-blue-50">
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-1">
              <div className="bg-blue-100 p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <span className="text-gray-500">Fecha límite</span>
            </div>
            <p className="font-medium text-gray-800 ml-10">{formatearFechaCompleta(servicio.fechaentrega)}</p>
          </div>
          
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-1">
              <div className="bg-green-100 p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <span className="text-gray-500">Valor</span>
            </div>
            <p className="font-medium text-gray-800 ml-10">{formatearPrecio(servicio?.preciocobrado)}</p>
          </div>
          
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-1">
              <div className="bg-purple-100 p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
              </div>
              <span className="text-gray-500">Código servicio</span>
            </div>
            <p className="font-medium text-gray-800 ml-10">{servicio?.codigo}</p>
          </div>

          {servicio?.identificadorcodigo == "A" && (
            <div className="bg-white p-4 rounded-lg shadow-sm border-border-gray-100">
              <div className="flex items-center gap-3 mb-1">
                <div className="bg-orange-100 p-2 rounded-full">
                  {/* Icono de Lucide React */}
                  <Video className="h-5 w-5 text-orange-600" strokeWidth={2} />
                </div>
                <span className="text-gray-500">Enlace de la reunión</span>
              </div>
              <a
                href={servicio?.ObjetoAsesoria?.hangoutLink}
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-blue-600 hover:underline ml-10"
              >
                Unirse a la reunión
              </a>
            </div>
          )}

        </div>

        <div className="p-6">

          {/* Descripción actividad - Pestañas mejoradas */}
          <div className="mb-8">
            <DescripcionActividadSolicitud 
                  solicitud={solicitud}
                  initialTab="descripcion"
                />
          </div>

          

          {/* LOGICA PARA ENTREGA DE TRABAJOS */} 
          {!servicio.getTrabajoEntregado()  && (servicio.identificadorcodigo !== "P" && servicio.identificadorcodigo != "Q" )? (
            <div className="bg-slate-50 border-2 border-slate-100 rounded-[32px] p-10 flex flex-col items-center text-center shadow-sm animate-in fade-in duration-700">
    
              {/* Icono animado de progreso */}
              <div className="relative mb-6">
                <div className="absolute inset-0 bg-blue-400 rounded-full animate-ping opacity-20"></div>
                <div className="relative bg-blue-600 p-5 rounded-full text-white shadow-xl shadow-blue-200">
                  <RefreshCw size={32} className="animate-spin-slow" />
                </div>
              </div>

              {/* Textos de Estado */}
              <h3 className="text-2xl font-black text-slate-900 uppercase tracking-tight mb-2">
                Tu trabajo está en progreso 🦉
              </h3>
              <p className="text-slate-500 text-sm font-medium max-w-sm leading-relaxed">
                Nuestros profesionales están trabajando actualmente en tu solicitud para garantizar la mejor calidad.
              </p>

              {/* Badge de fecha estimada */}
              <div className="mt-8 flex items-center gap-3 px-5 py-3 bg-white rounded-2xl border border-slate-200 shadow-sm">
                <div className="bg-blue-50 p-2 rounded-lg text-blue-600">
                  <Clock size={18} />
                </div>
                <div className="text-left">
                  <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest leading-none mb-1">Entrega estimada</p>
                  <p className="text-sm font-bold text-slate-700">{formatearFechaCompleta(servicio.fechaentrega)}</p>
                </div>
              </div>

            </div>
          ) : servicio.getSaldoPendienteCliente() > 0 ? (
            // ESTADO 2: TRABAJO LISTO PERO REQUIERE PAGO
            <div className="bg-amber-50 border-2 border-amber-200 rounded-[32px] p-10 flex flex-col items-center text-center shadow-sm animate-in zoom-in duration-500">
              <div className="bg-amber-100 p-5 rounded-full text-amber-600 mb-6 shadow-xl shadow-amber-200">
                <Lock size={32} />
              </div>
              
              <h3 className="text-2xl font-black text-amber-900 uppercase tracking-tight mb-2">
                ¡Tu trabajo está listo! 🚀
              </h3>
              <p className="text-amber-700 text-sm font-medium max-w-sm mb-6">
                Para desbloquear y descargar tus archivos finales, por favor completa el pago pendiente.
              </p>


              <FileViewerBien
                files={servicio.previewEntrega}
                titulo={"Avances de la tarea."}
                esVistaPrevia={true}
              />

              {/* HABILITACIÓN DE PAGOS PARA DESBLOQUEAR */}
              <ContainerPagos
                precioACobrar={servicio.preciocobrado}
                categoria={"SERVICIO"}
                idReferencia={servicio.codigo}
                sumaPagosClientes={servicio.getSumaPagosClientes()}
                nombreEmpresa={servicio.nombreEmpresa}
                identificador={servicio.codigo}
              />
              
            </div>
          ) : (
            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 mb-8 shadow-sm">
              <div className="flex items-center justify-center mb-4">
                <div className="h-16 w-16 bg-green-100 rounded-full flex items-center justify-center">
                  <CheckCircle className="h-10 w-10 text-green-600" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-green-700 mb-2">
                ¡Trabajo desbloqueado con éxito!
              </h3>
              <p className="text-center text-green-600 mb-6">
                Ya puedes descargar tus archivos originales.
              </p>

              {/* Vista de archivos ORIGINALES (FileViewer) */}
              <FileViewer 
                IdCarpeta={servicio.codigo}
                nombreEmpresa={nombreEmpresaReal}
                onDeleteFile={(files) => {}}
              />
            </div>
          )}

        </div>
        
      </div>
      );
  }

  return (
    <div>

      {/* Navegación de tabs mejorada */}
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
                  <nav className="flex space-x-1 overflow-x-auto scrollbar-hide p-2">
                    {visibleTabs.map((tab) => (
                      <button
                        key={tab.id}
                        onClick={() => handleTabChange(tab.id)}
                        className={`group relative py-4 px-6 font-medium text-sm flex items-center gap-3 whitespace-nowrap flex-shrink-0 transition-all duration-300 rounded-2xl ${
                          activeTab === tab.id
                            ? 'bg-white text-blue-700 shadow-lg transform -translate-y-0.5'
                            : 'text-gray-600 hover:text-gray-800 hover:bg-white hover:bg-opacity-60'
                        }`}
                      >
                        {/* Indicador activo */}
                        {activeTab === tab.id && (
                          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-blue-500 rounded-full"></div>
                        )}
                        
                        <div className={`p-2 rounded-lg transition-colors ${
                          activeTab === tab.id ? 'bg-blue-100' : 'bg-gray-200 group-hover:bg-gray-300'
                        }`}>
                          <tab.icon size={16} className={activeTab === tab.id ? 'text-blue-600' : 'text-gray-500'} />
                        </div>
                        
                        <div className="flex flex-col items-start">
                          <span className="hidden sm:inline font-semibold">{tab.label}</span>
                          <span className="sm:hidden font-semibold">
                            {tab.id === 'general' ? 'General' : 
                            tab.id === 'cotizaciones' ? 'Cotiz.' : 
                            tab.id === 'notificaciones' ? 'Notif.' : 'Vistas'}
                          </span>
                          
                          {tab.count !== undefined && tab.count > 0 && (
                            <span className={`mt-1 px-2 py-0.5 text-xs rounded-full font-bold transition-colors ${
                              tab.id === 'cotizaciones' 
                                ? 'bg-green-500 text-white'
                                : tab.id === 'vistas'
                                ? 'bg-blue-500 text-white'
                                : tab.id === 'notificaciones'
                                ? 'bg-orange-500 text-white'
                                : 'bg-gray-500 text-white'
                            }`}>
                              {tab.count}
                            </span>
                          )}
                        </div>
                      </button>
                    ))}
                  </nav>
      </div>

      {/* Contenido de las tabs con padding mejorado */}
      <div className="p-8">
        {activeTab === 'general' && ClienteView()}
        
        {/* PROGRAMAR TESIS */}
        {activeTab === 'tesis' && <ConstruccionWidget />}
         {/* PROGRAMAR ENTREGAS */}
        {activeTab === 'entregas' && <ConstruccionWidget/>}

        {activeTab === 'revision' && 
          <ModuloRevision 
            servicio={servicio} 
            isAdmin={false}
            chatHabilitado = {false}
          />
        }
        
        

        

      </div>
    </div>
  )
}

export default ClienteViewServicio
